import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectAgencies = (state: RootState) => state.agencies;

export const selectAgenciesData = createSelector([selectAgencies], ({ data, filters, total, dataRequestId }) => ({
  data,
  filters,
  total,
  loading: !!dataRequestId,
}));

export const selectAgenciesFilters = createSelector([selectAgencies], ({ filters }) => filters);

export const selectSelectedAgency = createSelector([selectAgencies], ({ selectedAgency }) => selectedAgency);
